(function () {
  'use strict';

  const SECTION_ID = 'cart-recomm';
  const SELECTORS = {
    mount: '#CartDrawer [data-cart-recommendations]',
    addBtn: '[data-cart-recommendation-add]',
    cartItems: '#CartDrawer [data-products]',
    track: '[data-kosz-recs-track]',
    arrow: '[data-kosz-recs-dir]',
  };

  let inFlight = null;
  let queued = false;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function fetchSectionHtml() {
    return fetch(root + 'cart?sections=' + SECTION_ID, { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((data) => data[SECTION_ID] || '');
  }

  function updateArrows(mount) {
    const track = mount.querySelector(SELECTORS.track);
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth - 1;
    mount.querySelectorAll(SELECTORS.arrow).forEach((arrow) => {
      const dir = parseInt(arrow.getAttribute('data-kosz-recs-dir'), 10);
      arrow.disabled = dir < 0 ? track.scrollLeft <= 0 : track.scrollLeft >= max;
    });
  }

  function cardSignatures(root) {
    const map = {};
    root.querySelectorAll('.kosz-rec').forEach((card) => {
      const link = card.querySelector('a[href]');
      if (link) map[link.getAttribute('href')] = card.textContent.replace(/\s+/g, ' ');
    });
    return map;
  }

  function markFresh(root, before) {
    const after = cardSignatures(root);
    root.querySelectorAll('.kosz-rec').forEach((card) => {
      const link = card.querySelector('a[href]');
      const key = link && link.getAttribute('href');
      if (key && before[key] !== after[key]) card.classList.add('kosz-fresh');
    });
  }

  function cartEmpty() {
    const items = document.querySelector(SELECTORS.cartItems + ' [data-count]');
    return !items || parseInt(items.getAttribute('data-count'), 10) === 0;
  }

  function refresh() {
    const mount = document.querySelector(SELECTORS.mount);
    if (!mount) return Promise.resolve();
    if (cartEmpty()) {
      mount.innerHTML = '';
      return Promise.resolve();
    }
    if (inFlight) {
      queued = true;
      return inFlight;
    }

    inFlight = fetchSectionHtml()
      .then((html) => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        const section = tmp.querySelector('.shopify-section') || tmp;
        const hadContent = mount.children.length > 0;
        const before = cardSignatures(mount);
        const track = mount.querySelector(SELECTORS.track);
        const scroll = track ? track.scrollLeft : 0;
        mount.innerHTML = section.innerHTML.trim();
        const nextTrack = mount.querySelector(SELECTORS.track);
        if (nextTrack) nextTrack.scrollLeft = scroll;
        if (hadContent) markFresh(mount, before);
        updateArrows(mount);
      })
      .catch(() => {
        mount.innerHTML = '';
      })
      .finally(() => {
        inFlight = null;
        if (queued) {
          queued = false;
          refresh();
        }
      });

    return inFlight;
  }

  function showError(button, err) {
    const card = button.closest('.kosz-rec');
    const box = card && card.querySelector('[data-kosz-rec-error]');
    const mount = document.querySelector(SELECTORS.mount);
    if (!box) return;
    box.textContent = (err && err.description) || (mount && mount.getAttribute('data-error')) || '';
    box.hidden = false;
  }

  function quickAdd(button) {
    const variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    button.disabled = true;
    button.setAttribute('data-loading', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { _added_via: 'cart-recommendation' } }],
      }),
    })
      .then((r) => {
        if (!r.ok) return r.json().then((e) => Promise.reject(e));
        return r.json();
      })
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

        if (window.jQuery) {
          try {
            window.jQuery(document).trigger('ajaxProduct:added');
            window.jQuery(document).trigger('cart:added');
          } catch (e) {}
        }
      })
      .catch((err) => {
        showError(button, err);
        button.disabled = false;
      })
      .finally(() => {
        button.setAttribute('data-loading', 'false');
      });
  }

  function scrollTrack(arrow) {
    const mount = arrow.closest('[data-cart-recommendations]');
    const track = mount && mount.querySelector(SELECTORS.track);
    if (!track) return;
    const dir = parseInt(arrow.getAttribute('data-kosz-recs-dir'), 10);
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: dir * track.clientWidth * 0.9, behavior: smooth ? 'smooth' : 'auto' });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest(SELECTORS.addBtn);
    if (btn) {
      e.preventDefault();
      quickAdd(btn);
      return;
    }
    const arrow = e.target.closest(SELECTORS.arrow);
    if (arrow) scrollTrack(arrow);
  });

  function watchCartContainer() {
    const cartItems = document.querySelector(SELECTORS.cartItems);
    const mount = document.querySelector(SELECTORS.mount);
    if (!cartItems || !mount) return;
    let timer = null;
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(() => afterLoad(refresh), 150);
    }).observe(cartItems, { childList: true, subtree: false });
    mount.addEventListener('scroll', () => updateArrows(mount), true);
    window.addEventListener('resize', () => updateArrows(mount));
    document.addEventListener('drawerOpen.CartDrawer', () => requestAnimationFrame(() => updateArrows(mount)));
    if (cartItems.children.length) afterLoad(refresh);
  }

  function afterLoad(fn) {
    const idle = () => (window.requestIdleCallback ? requestIdleCallback(fn) : setTimeout(fn, 0));
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle, { once: true });
  }

  function init() {
    watchCartContainer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.cartRecommendations = { refresh };
})();
